import type { ResourcesResponse } from "@rago/web-shared";
import { api } from "./apiClient";
import { isLocalMode } from "./appMode";
import { fetchLocalResources } from "./localResources";

/**
 * The ["resources"] query, shared by useServers, useSources and the pollers
 * that need it faster for a moment (claim page, remote-access check). Hosted:
 * the broker's list of every claimed server. Local mode: the one server this
 * page is served by, synthesized from its own /v1/server and /v1/me — no
 * broker round trip, so it also answers with the cloud down.
 */
export const resourcesQuery = {
  queryKey: ["resources"] as const,
  queryFn: (): Promise<ResourcesResponse> =>
    isLocalMode
      ? fetchLocalResources()
      : api<ResourcesResponse>("/v1/resources?include=connections,serverTokens"),
};
